import { GEOCODING_SOURCE } from '../geolocation';
import { SITE_TYPE } from '../site/site.interface';
import type { TenantInitialSite } from '../tenant';
import { ObjectFactory } from './object.factory';

export class TenantInitialSiteFactory extends ObjectFactory<TenantInitialSite> {
  protected getDefaults(): TenantInitialSite {
    return {
      code: 'main-warehouse',
      location: {
        address: { city: 'Paris', country: 'FR', postalCode: '75001', street: '1 rue de Paris' },
        coordinates: { latitude: 48.8566, longitude: 2.3522, score: 1, source: GEOCODING_SOURCE.MANUAL },
      },
      name: 'Main Warehouse',
      phone: { dialCode: '+33', number: '612345678' },
      type: SITE_TYPE.WAREHOUSE,
    };
  }
}

export type { TenantInitialSite };
export const tenantInitialSiteFactory = new TenantInitialSiteFactory();
